module.exports = __webpack_public_path__ + "static/media/money-pence-fifty.fae65464.svg";